module.exports = {
    getChoices: function(){
        return require('./components/Choices')
    },
    dynamicRequire: require('./dynamicRequire'),
};


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/index.js